
import Vue from 'vue';
import axios from 'axios';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LIcon, LPopup } from 'vue2-leaflet';

interface LocalMarker {
  id: number;
  name: string;
  LatLng: [number, number];
  icon: string;
}

interface WpLocalPost {
  title?: { rendered?: string };
  acf?: {
    gps?: {
      lat?: number;
      lng?: number;
      markers?: Array<{ lat?: number; lng?: number }>;
    };
  };
}

export default Vue.extend({
  name: 'Map',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
  },
  data() {
    return {
        zoom: 11,
        center: [50.3176901, 19.0979497] as [number, number],
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        markers: [] as LocalMarker[],
    };
  },
  created() {
    axios
      .get<WpLocalPost[]>('https://rckik-katowice.pl/wp-json/wp/v2/lokale?per_page=100&_embed')
      .then((response) => {
        const posts = Array.isArray(response.data) ? response.data : [];
        this.markers = posts.reduce<LocalMarker[]>((acc, post, index) => {
          const gps = post.acf && post.acf.gps;
          const point = (gps && gps.markers && gps.markers[0]) || gps;
          const lat = point && typeof point.lat === 'number' ? point.lat : null;
          const lng = point && typeof point.lng === 'number' ? point.lng : null;
          const name = (post.title && post.title.rendered) || '';
          if (lat !== null && lng !== null && name) {
            acc.push({
              id: index,
              name,
              LatLng: [lat, lng],
              icon: 'svg/marker.svg',
            });
          }
          return acc;
        }, []);
        this.$nextTick(() => this.fitToMarkers());
      })
      .catch(() => {
        this.markers = [];
      });
  },
  methods: {
    fitToMarkers() {
      if (!this.markers.length) {
        return;
      }
      const mapRef = this.$refs.map as { mapObject?: L.Map } | undefined;
      const map = mapRef && mapRef.mapObject;
      if (!map) {
        return;
      }
      const inPoland = this.markers
        .map((m) => m.LatLng)
        .filter(([lat, lng]) => lat >= 49 && lat <= 54.9 && lng >= 14.1 && lng <= 24.2);
      const points = inPoland.length ? inPoland : this.markers.map((m) => m.LatLng);
      const bounds = L.latLngBounds(points);
      map.fitBounds(bounds, { padding: [40, 40] });
    },
  },
});
